import { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const IconExportFile: FC<IProps> = ({ width = 16, height = 16 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4414 5.85449C12.4676 5.85681 12.4939 5.867 12.5176 5.88574L15.0508 7.88574C15.0679 7.89911 15.0823 7.91606 15.0918 7.93555C15.1012 7.95497 15.1055 7.97646 15.1055 7.99805C15.1054 8.01963 15.1013 8.04114 15.0918 8.06055C15.0823 8.07995 15.0678 8.09606 15.0508 8.10938L12.5176 10.1094C12.4252 10.184 12.2863 10.1171 12.2861 9.99805V8.64062H12.2852V8.63965H6.67871C6.60054 8.63965 6.53628 8.57618 6.53613 8.49805V7.49805C6.53613 7.41978 6.60045 7.35547 6.67871 7.35547H12.2852V7.35449H12.2861V5.99805C12.2861 5.90865 12.3631 5.84755 12.4414 5.85449ZM2.37695 2.375H2.37598V13.6211H13.6221V12.5176C13.6221 12.4989 13.6258 12.4812 13.6328 12.4648C13.6468 12.432 13.6732 12.4056 13.7061 12.3916C13.7224 12.3846 13.7401 12.3809 13.7588 12.3809H14.7197C14.7752 12.381 14.8235 12.4143 14.8447 12.4629C14.852 12.4796 14.8564 12.498 14.8564 12.5176V14.3066L14.8447 14.417C14.8084 14.5955 14.6863 14.7423 14.5225 14.8115C14.4894 14.8255 14.4549 14.8364 14.4189 14.8438C14.3833 14.851 14.3464 14.8545 14.3086 14.8545H1.69043C1.57654 14.8544 1.47126 14.8199 1.38379 14.7607C1.26743 14.6821 1.18331 14.5598 1.1543 14.417C1.14705 14.3813 1.14355 14.3445 1.14355 14.3066V1.68848C1.14358 1.65061 1.14702 1.61379 1.1543 1.57812C1.19071 1.39963 1.31365 1.25367 1.47754 1.18457C1.54305 1.15695 1.61469 1.14165 1.69043 1.1416H14.3105C14.3866 1.14162 14.4587 1.15676 14.5244 1.18457C14.688 1.25377 14.8103 1.39988 14.8467 1.57812C14.854 1.61381 14.8584 1.6506 14.8584 1.68848V3.47852L14.8477 3.53223C14.8406 3.5486 14.8298 3.56289 14.8174 3.5752C14.805 3.58747 14.7907 3.59762 14.7744 3.60449C14.7579 3.61149 14.7396 3.61523 14.7207 3.61523H13.7607L13.708 3.60449C13.6752 3.59059 13.6489 3.56395 13.6348 3.53125L13.623 3.47852V2.37402H2.37695V2.375Z"
        fill="white"
        stroke="white"
        strokeWidth="0.00111607"
      />
    </svg>
  );
};

export default IconExportFile;
